import { render } from "./ClockComponent.vue?vue&type=template&id=3d6ed86b&scoped=true&ts=true"
import script from "./ClockComponent.vue?vue&type=script&lang=ts"
export * from "./ClockComponent.vue?vue&type=script&lang=ts"

import "./ClockComponent.vue?vue&type=style&index=0&id=3d6ed86b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6ed86b"]])

export default __exports__